import { ResponsiveModal } from "@tiendeo/react-components/dist/objects/Modal/ResponsiveModal";
import { StyledWrapper, StyledTitle, StyledText } from "./ConfirmationModal.styles";
import useTranslation from "translations/useTranslation";

interface ConfirmationModalProps {
    isError: boolean;
    isOpen: boolean;
    isManagement?: boolean;
    isNewsletter?: boolean;
    onClose: () => void;
}

const ConfirmationModal = ({
    isOpen,
    onClose,
    isError,
    isManagement,
    isNewsletter,
}: ConfirmationModalProps) => {
    const t = useTranslation();

    return (
        <ResponsiveModal isOpen={isOpen} onClose={onClose}>
            <StyledWrapper data-testid="ConfirmationAlerts_modal">
                {isManagement ? (
                    <>
                        <StyledTitle>{t("PERFECT")}</StyledTitle>
                        <StyledText>{t("ALERTS_UPDATED")}</StyledText>
                    </>
                ) : isNewsletter ? (
                    <>
                        <StyledTitle>{t("PERFECT")}</StyledTitle>
                        <StyledText>{t("NEWSLETTER_UPDATED")}</StyledText>
                    </>
                ) : !isError ? (
                    <>
                        <StyledTitle>{t("PERFECT")}</StyledTitle>
                        <StyledText>{t("MAIL_SENT")}</StyledText>
                    </>
                ) : (
                    <StyledText>{t("GENERIC_ERROR_MESSAGE")}</StyledText>
                )}
            </StyledWrapper>
        </ResponsiveModal>
    );
};

export default ConfirmationModal;
